import type { FaqItem } from '../types/content'

export const faqs: FaqItem[] = [
  {
    question: '¿Sirve si no sé cocinar o soy principiante?',
    answer:
      'Sí, 100%. El Tomo 1 arranca desde cero con el sistema más básico posible. No necesitás saber cocinar — necesitás seguir el método. Si podés hervir agua y usar una sartén, podés hacer todo lo del pack.',
  },
  {
    question: '¿Cómo recibo el material después de pagar?',
    answer:
      'Acceso inmediato. En menos de 5 minutos después del pago recibís el link de descarga en tu email. Todo en PDF, compatible con celular, tablet y computadora. Sin apps, sin plataformas, sin contraseñas.',
  },
  {
    question: '¿Los ingredientes son fáciles de conseguir en Argentina?',
    answer:
      'Todo el sistema está pensado 100% para Argentina. Feria, verdulería, Día, Carrefour, Coto — lo que ya usás. Nada importado, nada raro, nada que no encuentres en tu barrio y a precio accesible.',
  },
  {
    question: '¿Qué lo diferencia de buscar recetas en YouTube o Instagram?',
    answer:
      'Las recetas de internet son recetas sueltas. El Mega Pack Cocina Lista es un sistema: tiene un método, un orden, listas de compras, tablas de conservación y planificadores. No buscás — abrís y seguís. Esa es la diferencia entre improvisar y tener el control.',
  },
  {
    question: '¿La garantía es real?',
    answer:
      'Completamente real. Escribís a closethegap14@gmail.com dentro de los 7 días posteriores a tu compra y te devolvemos el 100% sin preguntas. Sin burocracia.',
  },
]
